import React from 'react';
import NoDataFound from '../../share-components/NoDataFound';

export function ProductPrintableContent({ printData, specificInfoElement }) {
    const printHeader = printData?.printHeader || "";
    const productListGroup = (printData?.productListGroup || []);
    // .sort((a, b) => a.categoryName.localeCompare(b.categoryName));
    const grandTotalQuantity = productListGroup.reduce((categorySum, category) => {
        return (
            categorySum +
            category.products.reduce((productSum, product) => productSum + product.totalQuantity, 0)
        );
    }, 0);
    let productIndex = 0;

    return (
        <div className="productPrintContent">
            <div style={{ textAlign: 'center', marginBottom: '10px' }}>
                <div style={{ fontSize: '16px', fontWeight: 'bold' }}>{printHeader}</div>
            </div>
            {specificInfoElement}
            <br />

            {productListGroup.length > 0 ?
                <table className='table table-bordered'>
                    <tbody>
                        <tr>
                            <td
                                style={{
                                    background: "black",
                                    color: "gold",
                                    fontWeight: "bolder",
                                    // textAlign: "right",
                                }}
                            >Grand Total Quantity:</td>
                            <td
                                style={{
                                    background: "black",
                                    color: "gold",
                                    fontWeight: "bolder",
                                }}
                            >{grandTotalQuantity}</td>
                        </tr>
                    </tbody>
                    {productListGroup.map((item, index) => (
                        <React.Fragment key={`${item.categoryId}_${index}`}>
                            <tbody className='text-center'>
                                <tr>
                                    <td className='pt-3' colSpan={2} style={{ fontWeight: 'bold' }}>
                                        <span style={{
                                            borderBottom: '1px solid black'
                                        }}>
                                            {item.categoryName}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                            {(item.products || [])
                                // .sort((a, b) => {
                                //     const brandCompare = a.brandName.localeCompare(b.brandName);
                                //     if (brandCompare !== 0) return brandCompare; // first sort by brandName
                                //     return a.productName.localeCompare(b.productName); // then sort by productName
                                // })
                                .map((product, p_index) => {
                                    // const isOdd = p_index % 2 !== 0;
                                    return (
                                        <React.Fragment key={`product_${index}_${p_index}`}>
                                            <tbody className="no-break-print">
                                                {product.colorSizeInfos.map((colorSize, cs_index) => {
                                                    const isOdd = productIndex % 2 !== 0;
                                                    productIndex += 1;
                                                    return (
                                                        <tr key={`cs_${p_index}_${cs_index}`}>
                                                            <td
                                                                style={{
                                                                    background: isOdd ? 'seashell' : 'cornsilk'
                                                                }}
                                                            ><span>{product.brandName?.trim()} </span>
                                                                <span>{product.productName?.trim()} </span>
                                                                {(colorSize.color || colorSize.size) && (
                                                                    <>
                                                                        {colorSize.color && <span>[{colorSize.color?.trim()}] </span>}
                                                                        {colorSize.size && <span>[{colorSize.size?.trim()}] </span>}
                                                                    </>
                                                                )}</td>
                                                            <td
                                                                style={{
                                                                    background: isOdd ? 'seashell' : 'cornsilk'
                                                                }}
                                                            ><span>x({colorSize.quantity})</span><br /></td>
                                                        </tr>)
                                                })}
                                                {/* <tr><td>Total Quantity:</td><td>{product?.totalQuantity}</td></tr> */}
                                            </tbody>
                                        </React.Fragment>
                                    )
                                })}
                        </React.Fragment>
                    ))}
                </table> : <NoDataFound />}
            <div style={{ textAlign: 'center', marginTop: '1rem' }}>✨ Have a nice day! ✨</div>
        </div>
    );
}



// import React from 'react';
// import { formatDateTime } from '../../services/UtilityService';

// export function PurchasePrintableContent({ printData, printDate }) {
//     const purchasedBy = printData?.purchasedBy || "";
//     const categoryName = printData?.categoryName || "";
//     const purchasedInfoList = printData?.purchasedInfoList || [];

//     return (
//         <div className="productPrintContent">
//             <div style={{ textAlign: 'center', marginBottom: '10px' }}>
//                 <div style={{ fontSize: '16px', fontWeight: 'bold' }}>Purchased History</div>
//             </div>
//             <table style={{ margin: '0 auto', textAlign: 'right' }}>
//                 <tbody>
//                     <tr><td>Purchased By:</td><td style={{ paddingLeft: '10px', textAlign: 'left' }}>{purchasedBy}</td></tr>
//                     <tr><td>Category:</td><td style={{ paddingLeft: '10px', textAlign: 'left' }}>{categoryName}</td></tr>
//                     <tr><td>Printed Date:</td><td style={{ paddingLeft: '10px', textAlign: 'left' }}>{formatDateTime(printDate)}</td></tr>
//                 </tbody>
//             </table>
//             <br />

//             {purchasedInfoList.map((item, index) => (
//                 <div key={index} style={{ marginBottom: '8px' }}>
//                     <strong>##{item.categoryName}</strong>
//                     {item.products.map((product, p_index) => (
//                         <React.Fragment key={`product_${index}_${p_index}`}>
//                             {product.colorSizeInfos.map((colorSize, cs_index) => (
//                                 <div key={`cs_${index}_${p_index}_${cs_index}`}>
//                                     <span>{product.brandName?.trim()} </span>
//                                     <span>{product.productName?.trim()} </span>
//                                     {(colorSize.color || colorSize.size) && (
//                                         <>
//                                             {colorSize.color && <span>[{colorSize.color?.trim()}] </span>}
//                                             {colorSize.size && <span>[{colorSize.size?.trim()}] </span>}
//                                         </>
//                                     )}
//                                     <span>x({colorSize.quantity})</span><br />
//                                 </div>
//                             ))}
//                             <hr className='m-0' />
//                         </React.Fragment>
//                     ))}
//                 </div>
//             ))}

//             <div style={{ textAlign: 'center', marginTop: '1rem' }}>✨ Have a nice day! ✨</div>
//         </div>
//     );
// }